import AppBarUser from "../../components/AppBarUser";
import CustomDivider from "../../components/CustomDivider";
import Solicitacao from "../../components/Solicitacao";

export default function DetalhesSolicitante() {
    return(
        <>
            <AppBarUser title="Detalhes" />
            <CustomDivider />
            <Solicitacao />
        </>
    )
}